import React, { useEffect, useRef, useState } from 'react'
import HeaderUser from '../components/homePage/HeaderUser'
import FooterPage from '../components/homePage/FooterPage'
import { useSelector } from 'react-redux';
import { ageCalculate, checkNameShowHide, decimalToFeetInches, decimalToFeetInchesWithoutWord, formatCount, formatDate, nameMask } from '../utils/utils';
import { Link, useNavigate } from 'react-router-dom';
import SuccessPopup from '../components/homePage/SuccessPopup';
import ConfirmPopup from '../components/homePage/ConfirmPopup';
import Cookies from "js-cookie";
import RightSideChatList from '../components/dashboard/RightSideChatList';
import { createUser } from '../services/chatService';

function Dashboard() {

  const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));


  const navigate = useNavigate();
  const { userDetailLogin } = useSelector((state) => state.auth);

  const [formData, setFormData] = useState({})
  const [formDataPhoto, setFormDataPhoto] = useState({})
  const fileInputRef = useRef(null);
  const [error, setError] = useState({})
  const [message, setMessage] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [checkPhoto, setCheckPhoto] = useState({})
  const [inviteAccept, setInviteAccept] = useState({})
  const [freeMember, setFreeMember] = useState([])
  const [premiumMember, setPremiumMember] = useState([])
  const modalSuccessRef = useRef(null)
  const modalInstanceSuccess = useRef(null);
  const [planDetailUser, setPlanDetailUser] = useState(0)
  const modalConfirmRef = useRef(null)
  const modalInstanceConfirm = useRef(null);
  const [popupMessage, setPopupMessage] = useState("")
  const [totalUserSentInterest, setTotalUserSentInterest] = useState()
  const [expiryDate, setExpiryDate] = useState(false)
  const [totalRecentCount, setTotalRecentCount] = useState(0)
  const [successPopupMsg, setSuccessPopupMsg] = useState("")
  const [totalUserView, setTotalUserView] = useState(0)
  const [totalDashboard, setTotalDashboard] = useState({})
  const [notificationList, setNotificationList] = useState([])
  const [notificationCount, setNotificationCount] = useState(0)
  const [matchList, setMatchList] = useState([]);
  const [userBride, setUserBride] = useState([]);
  const [userGrooms, setUserGrooms] = useState([]);
  const [me, setMe] = useState(null);
  const firebaseUserCreatedRef = useRef(false);

  const searchList = async () => {

    setMatchList([])
    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/search-list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        member_id: userDetailLogin?._id,
        page: 1,
        sortBy: "new",
        my_matches: 1
      }),


    });

    const data = await res.json();

    setMatchList(data.data)
    setUserBride(data.usersBride)
    setUserGrooms(data.usersGrooms)


  }

  const fetchUserDetail = async (userId) => {

    const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
    });

    const data = await res.json();
    //console.log(data)
    if (data.status) {


      const dob = new Date(data.data[0].dob);
      let ampm = "AM";
      let hour = dob.getHours();
      if (hour >= 12) {
        ampm = "PM";
        if (hour > 12) hour -= 12;
      } else if (hour === 0) {
        hour = 12;
      }



      // console.log(data.data[0]) 

      let profilePhoto;
      if (data.data[0].profile_photo === 1) {
        profilePhoto = data.data[0].photo
      } else if (data.data[0].profile_photo === 2) {
        profilePhoto = data.data[0].photo1
      } else if (data.data[0].profile_photo === 3) {
        profilePhoto = data.data[0].photo2
      } else if (data.data[0].profile_photo === 4) {
        profilePhoto = data.data[0].photo3
      } else if (data.data[0].profile_photo === 5) {
        profilePhoto = data.data[0].photo4
      } else {
        profilePhoto = data.data[0].photo
      }


      const isExpired = new Date(data.data[0].plan_detail?.expiry_date) < new Date();
      setExpiryDate(isExpired)

      setTotalUserSentInterest(data.data[0].interest_user)
      setPlanDetailUser(data.data[0].plan_detail)
      setTotalRecentCount(formatCount(data.data[0].totalRecentUserView || 0))
      setTotalUserView(data.data[0].total_user_view)



      setTotalDashboard({
        totalSent: formatCount(data?.data[0]?.interest_user || 0),
        totalAccept: formatCount(data?.data[0]?.accepted_invitation || 0),
        totalReceived: formatCount(data?.data[0]?.receivedInvitation || 0),
        totalShortlist: formatCount(data?.data[0]?.shortlisted || 0),
        totalViewContact: data?.data[0]?.totalViewContact
      })

      setFormData({
        id    : data.data[0]._id,
        profile_id: data.data[0].profile_id,
        gender: data.data[0].gender,
        name: data.data[0].name,
        photo: profilePhoto,
        planDetail: data.data[0].plan_detail,
        aadhaar_no: data.data[0]?.aadhaar_no,
        policeApproval: data.data[0]?.policeApproval,
        educationApproval: data.data[0]?.educationApproval,
        jobIncomeApproval: data.data[0]?.jobIncomeApproval,
        casteApproval: data.data[0]?.casteApproval

      })

      setCheckPhoto({
        photo: data.data[0].photo,
        photo1: data.data[0].photo1,
        photo2: data.data[0].photo2,
        photo3: data.data[0].photo3,
        photo4: data.data[0].photo4,


      })

    } else {

    }

  }



  useEffect(() => {

    if (userDetailLogin?._id) {
      fetchUserDetail(userDetailLogin._id)
    }

  }, [userDetailLogin])

  const handleClick = () => {
    fileInputRef.current.click();
  };



  const handleChange = async (e) => {
    const { name, files } = e.target;


    if (name === "photo") {
      const file = files[0];

      if (!file) return;

      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        alert("Please select a JPG or PNG image.");
        return;
      }
      const fileSizeInMB = file.size / (1024 * 1024);

      if (fileSizeInMB > 10) {
        alert("Upload image not allowed more than 10MB.");
        return;
      }

      /*  if (file) {
         const reader = new FileReader();
         reader.onloadend = () => {
           if(name === 'photo'){
           //  setPreviewUrl(reader.result);
           }
           
           
         };
         reader.readAsDataURL(file);
       }
         */

      /* setFormDataPhoto((prevData) => ({
        ...prevData,
        [name]:files[0],
      }));

      */

      setIsLoading(true)
      const formDataToSubmit = new FormData();
      formDataToSubmit.append("id", userDetailLogin._id);
      if (formData.photo) formDataToSubmit.append("photo", files[0]);

      const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/profile-photo-user`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formDataToSubmit,

      });

      const data = await res.json();
      setIsLoading(false)

      if (data.status) {
        //dispatch(verifyOtp(data));

        //setMessage({photo:data.message})
        setError({})
        fetchUserDetail(userDetailLogin._id)

        setSuccessPopupMsg(data.message)
        modalInstanceSuccess.current?.show();
        setTimeout(() => {
          modalInstanceSuccess.current?.hide();
        }, 2000)


      } else {
        //console.log(data)
        if (data.errors) {
          // Convert array to object keyed by field
          const errorObj = {};
          data.errors.forEach(error => {
            errorObj[error.path] = error.msg;
          });
          setError(errorObj);
        }


        setError({ photo: data.message })
        setMessage({})
      }




      return;
    }






  };



  const fetchListMember = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/inbox`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          pageType: 'sent',
          member_id: userDetailLogin._id,
        }),
      });

      const data = await response.json();

      if (response.ok) {

        //console.log(data.data)
        const result = {
          pendingCount: formatCount(data.data?.filter(p => p.status === "Pending").length || 0),
          acceptedCount: formatCount(data.data?.filter(p => p.status === "Accepted").length || 0),
          acceptedPremiumCount: formatCount(data.data?.filter(p => p.status === "Accepted" && p.partner_id?.plan_detail?.plan_id?.name === 'Premium').length || 0)
        };
        // console.log(result)
        setInviteAccept(result)



      } else {
        console.error("Error fetching members:", data.error || data.message);
      }
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const fetchGetAllMatchMember = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/member-match`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          totalResult: 3,
          user_id: userDetailLogin._id,
        }),
      });

      const data = await response.json();

      if (data.status) {

        //console.log(data.usersFree)

        setFreeMember(data.usersFree)
        setPremiumMember(data.usersPremium)



      } else {
        console.error("Error fetching members:", data.error || data.message);
      }
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  const fetchNotificationList = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/notifications`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
      });

      const data = await response.json();

      if (data.status) {
        setNotificationList(data.data || []);
        setNotificationCount(data.totalCount || data.data?.length || 0);
      } else {
        setNotificationList([]);
        setNotificationCount(0);
      }
    } catch (error) {
      setNotificationList([]);
      setNotificationCount(0);
      console.error("Fetch failed:", error);
    }
  };

  const getNotificationMemberPhoto = (member) => {
    if (member?.photo) {
      return `${process.env.REACT_APP_BASE_URL_IMAGE}${member.photo}`;
    }

    if (member?.gender === "Female") {
      return "assets/img/no-image-female.jpg";
    }

    if (member?.gender === "Male") {
      return "assets/img/no-image-male.jpg";
    }

    return "assets/img/no-image.jpg";
  }

  useEffect(() => {
    fetchListMember()
    fetchGetAllMatchMember()
    searchList()
    fetchNotificationList()
  }, [])

  useEffect(() => {
    if (userDetailLogin?._id) {
      fetchNotificationList()
    }
  }, [userDetailLogin])

  useEffect(() => {
    const modalSuccessEl = document.getElementById("successPopup");
    if (modalSuccessEl) {
      modalInstanceSuccess.current = new window.bootstrap.Modal(modalSuccessEl);
    }

  }, []);

  const sendInterest = (id, index, val) => {

    if (userDetailLogin?._id) {


      if (!planDetailUser || (planDetailUser?.plan_id?.name === 'Basic' && totalUserSentInterest > parseInt(planDetailUser?.send_interest))) {
        setPopupMessage(`You're currently on the Basic plan. Kindly upgrade your plan to continue.`)
        modalInstanceConfirm.current?.show();

      } else if (planDetailUser?.plan_id?.name === 'Gold' && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) {
        setPopupMessage(`You've reached the limit of 50 member interests. Kindly upgrade your plan to continue.`)
        modalInstanceConfirm.current?.show();

      } else if (planDetailUser?.plan_id?.name === 'Premium' && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) {
        setPopupMessage(`You've reached the limit of 300 member interests. Kindly upgrade your plan to continue.`)
        modalInstanceConfirm.current?.show();

      } else if (expiryDate && (planDetailUser?.plan_id?.name === 'Gold' || planDetailUser?.plan_id?.name === 'Premium')) {
        setPopupMessage(`Your membership plan has expired. Kindly upgrade your plan to continue.`)
        modalInstanceConfirm.current?.show();
      } else {
        interest(id, userDetailLogin?._id, index, val);
      }
    } else {

      return;

    }

  }
  const interest = async (partner_id, member_id, index, val) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_API}/api/user/sent-interest`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            partner_id: partner_id,
            member_id: member_id
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // console.log("Interest sent successfully:", data);
        setSuccessPopupMsg("Your interest has been sent.")
        modalInstanceSuccess.current?.show();
        setTimeout(() => {
          modalInstanceSuccess.current?.hide();
        }, 2000)

        if (val === 1) {
          setFreeMember((prevData) => {
            const updated = [...prevData];
            updated[index] = {
              ...updated[index],
              interest_sent: true,
            };
            return updated;
          });

        } else {

          setPremiumMember((prevData) => {
            const updated = [...prevData];
            updated[index] = {
              ...updated[index],
              interest_sent: true,
            };
            return updated;
          });
        }

      } else {
        console.error("Failed to send interest:", data.message || data);
      }
    } catch (error) {
      console.error("Error while sending interest:", error);
    }
  }

  useEffect(() => {
    const modalConfirmEl = document.getElementById("confirmPopupId");
    if (modalConfirmEl) {
      modalInstanceConfirm.current = new window.bootstrap.Modal(modalConfirmEl);
    }

  }, []);
  const yesNoButton = (value) => {
    //console.log('confirm', value)
    if (value === 'Yes') {
      navigate("/membership-plan")
    }
    modalInstanceConfirm.current?.hide();
  }

  let blurPhoto = 0
  if (!planDetailUser || Object.keys(planDetailUser).length === 0 || planDetailUser?.plan_id?.name === 'Basic' || (planDetailUser?.plan_id?.name === 'Gold' && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) || (planDetailUser?.plan_id?.name === 'Premium' && totalUserSentInterest > parseInt(planDetailUser?.send_interest)) || (expiryDate && (planDetailUser?.plan_id?.name === 'Gold' || planDetailUser?.plan_id?.name === 'Premium'))) {
    //console.log('blur photo')
    blurPhoto = 1

  }

  const showPopUpButton = (e, url) => {
    e.preventDefault()
    //setLoginProps(url);
    if (userDetailLogin?._id) {
      //console.log(planDetailUser?.profile_view)
      if (planDetailUser?.profile_view === 'unlimited') {

        navigate(url)

      } else if (!planDetailUser || (totalUserView > parseInt(planDetailUser?.profile_view))) {
        setPopupMessage(`You're currently on the ${planDetailUser?.plan_id?.name || 'Basic'} plan. Kindly upgrade your plan to continue.`)
        modalInstanceConfirm.current?.show();

      } else {

        navigate(url)

      }

    } else {

      //modalInstance.current?.show();

      //return;

    }


  }

// firebase messaging setup for chat
useEffect(() => {
  if (!formData || !formData?.profile_id) {
    setMe(null);
    return;
  }

  setMe({
    id: String(formData.profile_id), // ✅ Firebase ID must be string
    primary_id: formData._id,
    name: formData.name,
    image: `https://vivashri.com/vivashribackend/${formData.photo}`,
    is_online: true,
    about: "Hey, I'm using chat",
    created_at: Date.now().toString(),
    email: formData.email || "",
    last_active: "",
    last_active_status: 0,
    online_status: 0,
    push_token: "",
  });
}, [formData]);


useEffect(() => {
  if (!me || !me.id || firebaseUserCreatedRef.current) return;

  firebaseUserCreatedRef.current = true; // ✅ stop re-create on reload

  const createChatUser = async () => {
    try {
      console.log("Creating Firebase user:", me.id);
      await createUser(me.id, me);
      console.log("Firebase user created");
    } catch (error) {
      console.error("Firebase error:", error);
    }
  };

  createChatUser();
}, [me]);


// registration
    const verification = {
      aadhaar: formData.aadhaar_no ? true : false,
      police: formData.policeApproval === "Verified",
      education: formData.educationApproval === "Verified",
      job: formData.jobIncomeApproval === "Verified",
      caste: formData.casteApproval === "Verified"
    };

    const verifiedStatus = 40;
    const policeVerified = 20;
    const educationVerified = 10;
    const incomeVerified = 20;
    const casteVerified = 10;

    let totalVerification = 0;

    if (verification.aadhaar) {
      totalVerification += verifiedStatus;
    }

    if (verification.police) {
      totalVerification += policeVerified;
    }

    if (verification.education) {
      totalVerification += educationVerified;
    }

    if (verification.job) {
      totalVerification += incomeVerified;
    }

    if (verification.caste) {
      totalVerification += casteVerified;
    }


  return (
    <>
      <HeaderUser />
      <SuccessPopup ref={modalSuccessRef} message={successPopupMsg} />
      <ConfirmPopup ref={modalConfirmRef} message={popupMessage} yesNoButton={yesNoButton} />
      <>
        <section className="inrbnr">
          <div className="container-fluid con-flu-padd">
            <div className="inrbnrContent">
              <h1>Dashboard </h1>
              <ul className="inrbrnNav">
                <li>
                  <Link to="/dashboard">
                    <img src="assets/img/icons/home.png" alt="home icon" />
                  </Link>
                  <img src="assets/img/icons/arrows.png" alt="arrows icons" />
                </li>

                <li>
                  <Link to="#">Dashboard</Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
        {/* Section End */}
        <section className="astrologersList pt-30 pb-50">
          <div className="container-fluids con-flu-padds">
            <div className="astroList">
              <div className="row m-0 ">
                <div className="col-lg-10 pad-rig-cl mobpad0">
                  <div className="head-desh mb-3">
                    <div className="row ">
                      <div className="col-12 col-sm-6">
                        <div className="h3">
                          {" "}
                          <h3>
                            Welcome <span> {formData.name}!</span>
                          </h3>
                        </div>
                        <p>
                          Now find your account activities and details here on one
                          click
                        </p>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="row justify-content-lg-end">
                          <div className="col-6 col-lg-4">
                            <Link to="/notification" style={{ textDecoration: "none" }}>
                              <div className="ic-num ">
                                <div className="row align-items-center justify-content-lg-end text-right ">
                                  <div className="col-3">
                                    <img
                                      src="assets/img/icons/bell_svgrepo.com.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="col-4">
                                    <h3>{formatCount(notificationCount || 0)}</h3>
                                  </div>
                                  <p>New Notifications</p>
                                </div>
                              </div>
                            </Link>
                          </div>
                          <div className="col-6 col-lg-4">
                            <Link to="/recent-visitors" style={{ textDecoration: "none" }}>
                              <div className="ic-num ">
                                <div className="row align-items-center justify-content-lg-end text-right">
                                  <div className="col-3">
                                    <img
                                      src="assets/img/icons/user-plus-alt-1_svgrepo.com.png"
                                      alt=""
                                    />
                                  </div>
                                  <div className="col-4">
                                    <h3> {totalRecentCount} </h3>
                                  </div>
                                  <p>Recent Visitors</p>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-lg-3 col-md-4">
                        <div className="img-desh-pro">

                          <Link to="/profile-photo-edit">
                            <img
                              src={formData.gender && (
                                formData?.photo
                                  ? `${process.env.REACT_APP_BASE_URL_IMAGE}${formData.photo}`
                                  : formData?.gender === "Male"
                                    ? "assets/img/no-image-male.jpg"
                                    : "assets/img/no-image-female.jpg"
                              )}
                              alt="" width={272} className='dashimg' />
                          </Link>
                          <div className="rel d-flex">
                            <div className="image-captions w-100">
                              <h6>{formData.name}</h6>
                              <p>(ID :&nbsp;{formData.profile_id}) &nbsp;</p>
                            </div>
                            <div className="image-captionss ">
                              <Link to="/basic-details-edit">
                                <img
                                  src="assets/img/icons/pen_svgrepo.com.png"
                                  alt=""
                                />
                              </Link>
                            </div>

                            {/* {(checkPhoto.photo && checkPhoto.photo1 && checkPhoto.photo2 && checkPhoto.photo3 && checkPhoto.photo4) ? null : */}
                              <div className="image-cap-ic dash-uplodicon">
                                {isLoading ? `Wait...` :
                                 <Link to={`/profile-photo-edit`}>
                                  <img
                                    src={`assets/img/icons/img-ic-plus.png`}
                                    alt=""
                                    // onClick={handleClick}

                                  />
                                  </Link>
                                }

                                

                                {/* <input
                                  type="file"
                                  id="fileInput"
                                  accept="image/*"
                                  ref={fileInputRef}
                                  name="photo"
                                  onChange={handleChange}

                                /> */}
                              </div>
                             {/* } */}
                            

                          </div>
                        </div>
                        {message.photo && <p className="green" style={{ color: 'green' }}>{message.photo}</p>}
                        {error.photo && <p className="error">{error.photo}</p>}
                      </div>
                      <div className="col-lg-6 col-md-8">
                        <div className="hed-desh pb-2">
                          <h6>Your Activity Summary</h6>
                        </div>
                        <div className="col-12">
                          <div className="bg-des-con">
                            <div className="col-12">
                              <div className="row">

                                { /* <div className="col-4">
                            <div className="ic-nums ">
                              <div className="row align-items-center ">
                                <div className="col-3">
                                   <div className='dashstat-icon'>
                                       <img src="assets/img/icons/team_svgrepo.com.png" alt="" />
                                   </div>                                  
                                </div>
                                <div className="col-4">
                                  <h3>{inviteAccept?.pendingCount}</h3>
                                </div>
                                <p>Pending Invitations</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="ic-nums ">
                              <div className="row align-items-center ">
                                <div className="col-3">
                                    <div className='dashstat-icon'>
                                       <img src="assets/img/icons/check-alt_svgrepo.com.png" alt="" />

                                    </div>
                                  
                                </div>
                                <div className="col-4">
                                  <h3>{inviteAccept?.acceptedCount}</h3>
                                </div>
                                <p>Accepted Invitations</p>
                              </div>
                            </div>
                          </div>
                          */ }


                                <div className="col-lg-9">
                                  <div className="row">
                                    <div className="col-lg-3 pe-lg-1">
                                      <Link to="/inbox/received">
                                        <div className="dashboardstat d-flex align-item-center justify-content-start">
                                          {/* <img src="assets/img/icons/team_svgrepo.com.png" alt=""> */}
                                          <div>
                                            <span>{totalDashboard.totalReceived}</span>
                                            <p>Received Invitations</p>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                    <div className="col-lg-3 pe-lg-1">
                                      <Link to="/inbox/accepted">
                                        <div className="dashboardstat dashboardstat2 d-flex align-item-center justify-content-start">
                                          {/* <img src="assets/img/icons/check-alt_svgrepo.com.png" alt=""> */}
                                          <div>
                                            <span>{totalDashboard.totalAccept}</span>
                                            <p>Accepted Invitations</p>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                    <div className="col-lg-3 pe-lg-1">
                                      <Link to="/shortlist">
                                        <div className="dashboardstat dashboardstat3 d-flex align-item-center justify-content-start">
                                          {/* <img src="assets/img/icons/team_svgrepo.com.png" alt=""> */}
                                          <div>
                                            <span>{totalDashboard.totalShortlist}</span>
                                            <p>Shortlisted Profiles</p>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                    <div className="col-lg-3">
                                      <Link to="/inbox/sent">
                                        <div className="dashboardstat dashboardstat4 d-flex align-item-center justify-content-start">
                                          {/* <img src="assets/img/icons/check-alt_svgrepo.com.png" alt=""> */}
                                          <div>
                                            <span>{totalDashboard.totalSent}</span>
                                            <p>Sent Invitations</p>
                                          </div>
                                        </div>
                                      </Link>
                                    </div>
                                  </div>
                                </div>



                                <div className="col-lg-3">
                                  <div className="ic-nu text-center">
                                    {formData.aadhaar_no && formData.aadhaar_no !== '' ?
                                      <>
                                       <Link data-bs-toggle="modal" data-bs-target="#reg-prog-pop">
                                        <img
                                          src="assets/img/icons/check-badge_svgrepo.com.png"
                                          alt=""
                                        />
                                      <p> Verified Profile</p>
                                       </Link>
                                      </>
                                      :
                                      <>
                                      <Link data-bs-toggle="modal" data-bs-target="#reg-prog-pop">
                                        <img
                                          src="assets/img/icons/unverified.png"
                                          alt=""
                                        />
                                       <p> Unverified</p>
                                        </Link>
                                      </>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="bg-prem-con">
                                <div className="col-12">
                                  <div className="row">
                                    <div className="col-2 text-center">
                                      {" "}
                                      <img
                                        src="assets/img/icons/padlock.png"
                                        alt=""
                                      />{" "}
                                    </div>
                                    <div className="col-10 h3-col-con">
                                      <h3>
                                        Only&nbsp;Premium&nbsp;Members can avail these
                                        benefits
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-12 pt-4">
                                  <div className="row">
                                    <div className="col-6  border-lef">
                                      <div className="ic-n ">
                                        <div className="row align-items-center justify-content-center text-center ">
                                          <div className="col-4 d-flex text-center p-0">
                                            {" "}
                                            <img
                                              src="assets/img/icons/mobile-alt-2_svgrepo.com.png"
                                              alt=""
                                            />
                                            {totalDashboard.totalViewContact === 'Unlimited' ?
                                              <h3 style={{ fontSize: '15px', paddingTop: '5px' }}>{totalDashboard.totalViewContact}</h3>
                                              :
                                              <h3>{totalDashboard.totalViewContact}</h3>
                                            }
                                          </div>
                                          <p>Contact Viewed</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-6">
                                      <div className="ic-n ">
                                        <div className="row align-items-center justify-content-center text-center ">
                                          <div className="col-4 d-flex text-center p-0">
                                            {" "}
                                            <img
                                              src="assets/img/icons/chat-round-dots_svgrepo.com.png"
                                              alt=""
                                            />
                                            <h3>03</h3>
                                          </div>
                                          <p>Chats initiated</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-4">
                        <div className="stand-plan-bg">
                          <h3>{formData.planDetail?.plan_id?.name === 'VIP' ? 'VIP Shaadi' : formData.planDetail?.plan_id?.name ? formData.planDetail?.plan_id?.name + ' Plan' : 'Basic Plan'}</h3>
                          <img src="assets/img/icons/standard-plan.png" alt="" />
                          <p>Plan name:&nbsp;{formData.planDetail?.plan_id?.name === 'VIP' ? 'VIP Shaadi' : formData.planDetail?.plan_id?.name ? formData.planDetail?.plan_id?.name : 'Basic'}</p>
                          <p>Validity:&nbsp;
                            {formData.planDetail?.plan_id?.name === 'VIP' ? 'Till Shaadi' : formData.planDetail?.plan_id?.name === 'Premium' ? '1 Year' : formData.planDetail?.plan_id?.name === 'Gold' ? '6 Month' : null}
                          </p>
                          <p>Valid till:&nbsp;{formData.planDetail?.expiry_date ? formatDate(formData.planDetail?.expiry_date) : formData.planDetail?.plan_id?.name === 'VIP' ? 'Till Shaadi' : null}</p>
                          <div className="butt">
                            {!planDetailUser ?
                              <Link to="/membership-plan"><button>Membership Plan</button></Link>
                              :
                              (planDetailUser?.plan_id?.name === 'Basic' || planDetailUser?.plan_id?.name === 'Gold' || planDetailUser?.plan_id?.name === 'Premium') ?
                                <Link to="/membership-plan"><button>Upgrade Plan</button></Link>
                                :
                                <Link to="/my-profile"><button>Complete Profile</button></Link>


                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="bg-col-matches">
                      <div className="row d-lg-flex align-items-lg-center">
                        <div className="col-lg-6 bord-matches">
                          <div className="row pad-match">
                            <div className="col-lg-4">
                              <div className="img-match">
                                <img
                                  src="assets/img/indian-wedding-character-collection.png"
                                  alt=""
                                />
                              </div>
                            </div>
                            <div className="col-lg-8 align-content-center">
                              <div className="con-matches">
                                <h6>
                                  Your Profile is how your Matches see you. Thanks for
                                  improving it
                                </h6>
                                <Link to="/today-matches"> <button>View Today Matches</button></Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 pad-match noti-cont">
                          <div className="row pad-top align-content-center align-items-center">
                            <div className="col-6 d-flex img-bell align-items-center">
                              <img src="assets/img/icons/bell-1.png" alt="" />
                              <h6>Notifications</h6>
                              <div className="not-count">
                                <h5>{formatCount(notificationCount || 0)}</h5>
                              </div>
                            </div>
                            <div className="col-6 ">
                              <div className="con-see-al text-end">
                                <Link
                                  style={{
                                    color: "#BE3272",
                                    fontSize: 17,
                                    fontWeight: 600
                                  }}
                                  to="/notification"
                                >
                                  See All
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            {notificationList.length > 0 ? (
                              notificationList.slice(0, 3).map((item) => (
                                <div className="bg-match-profile mb-2" key={item.id}>
                                  <div className="d-flex">
                                    <div className=" img-mess-2">
                                      <img src={item.member ? getNotificationMemberPhoto(item.member) : "assets/img/icons/bell-1.png"} alt="" />
                                    </div>
                                    <div className="con-metch">
                                      <h5>{item.member?.name || item.title}</h5>
                                      <p>{item.message}</p>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="bg-match-profile">
                                <div className="d-flex">
                                  <div className=" img-mess-2">
                                    <img src="assets/img/icons/bell-1.png" alt="" />
                                  </div>
                                  <div className="con-metch">
                                    <h5>Notifications</h5>
                                    <p>No notifications found.</p>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-5 mb-3">
                    <div className="row plane-matches">
                      <div className="col-lg-6">
                        <div className="col-12">
                          <div className="row">
                            <div className="col-6">
                              <h4 className='yourmatch-hd'>
                                Your Matches
                              </h4>
                            </div>
                            <div className="col-6 text-end">
                              <Link
                                style={{ color: "#BE3272", fontSize: 17 }}
                                to="/my-matches"
                              >
                                See All
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          {freeMember.length > 0 &&
                            <div className="bg-your-matches p-3">

                              {freeMember && freeMember.map((searchList, index) => {

                                let profilePhoto;
                                if (searchList.profile_photo === 1) {
                                  profilePhoto = searchList.photo
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo_blur
                                  }
                                } else if (searchList.profile_photo === 2) {
                                  profilePhoto = searchList.photo1
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo1_blur
                                  }
                                } else if (searchList.profile_photo === 3) {
                                  profilePhoto = searchList.photo2
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo2_blur
                                  }
                                } else if (searchList.profile_photo === 4) {
                                  profilePhoto = searchList.photo3
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo3_blur
                                  }
                                } else if (searchList.profile_photo === 5) {
                                  profilePhoto = searchList.photo4
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo4_blur
                                  }
                                } else {
                                  profilePhoto = searchList.photo
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo_blur
                                  }
                                }

                                return (
                                  <div className="col-12 py-2 ">
                                    <div className='yourmatch'>
                                      <div className="row">
                                        <div className="col-4 col-lg-3">
                                          <Link to="#" onClick={(e) => showPopUpButton(e, `/profile-details/${searchList._id}`)}>
                                            <img
                                              src={profilePhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}` : searchList.gender === 'Male' ? 'assets/img/no-image-male.jpg' : 'assets/img/no-image-female.jpg'}
                                              alt="" width={87} />
                                          </Link>
                                        </div>
                                        <div className="col-8 col-lg-6 match-pr-1 p-0">
                                          <h4><Link to="#" onClick={(e) => showPopUpButton(e, `/profile-details/${searchList._id}`)} style={{ color: '#BE3272' }}>

                                            {checkNameShowHide(searchList?.profileSettings?.name_show, planDetailUser) ? searchList?.name : nameMask(searchList?.name)}{" "}

                                          </Link></h4>
                                          <p> {searchList?.dob ? `${ageCalculate(searchList.dob)} yrs,` : ""} {searchList?.height ? `${decimalToFeetInchesWithoutWord(searchList.height)},` : ""} {searchList.religion?.name ? `${searchList.religion?.name},` : ''} {[searchList?.loc_city?.name].filter(Boolean).join("")}</p>
                                          <p>{searchList?.occupation?.name}</p>
                                        </div>
                                        <div className="col-12 col-lg-3">
                                          {


                                            searchList?.interest_sent ? (
                                              <>

                                                <Link to="#" className='dash-interst-btn' style={{ cursor: 'default' }}>
                                                  <img className="img-checker" src="assets/img/icons/check-alt_svgrepo.com-match.png"
                                                    alt="" />
                                                  <span>
                                                    Interest Sent
                                                  </span>
                                                </Link>
                                              </>

                                            )
                                              :
                                              (
                                                <>
                                                  <Link to="#" className='dash-interst-btn' onClick={() => sendInterest(searchList._id, index, 1)}>
                                                    <img className="img-checker" src="assets/img/icons/check-alt_svgrepo.com-match.png"
                                                      alt="" />
                                                    <span>
                                                      Express Interest
                                                    </span>
                                                  </Link>
                                                </>
                                              )

                                          }
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                )

                              })
                              }




                            </div>
                          }
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="col-12">
                          <div className='yourmatch'>
                            <div className="row mt-4 mt-lg-0">
                              <div className="col-8">
                                <h4 className='yourmatch-hd'>
                                  Premium Matches
                                </h4>
                              </div>
                              <div className="col-4 text-end">
                                <Link
                                  style={{ color: "#BE3272", fontSize: 17 }}
                                  to="/my-matches"
                                >
                                  See All
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          {premiumMember.length > 0 &&
                            <div className="bg-your-matches p-3">

                              {premiumMember && premiumMember.map((searchList, index) => {

                                let profilePhoto;
                                if (searchList.profile_photo === 1) {
                                  profilePhoto = searchList.photo
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo_blur
                                  }
                                } else if (searchList.profile_photo === 2) {
                                  profilePhoto = searchList.photo1
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo1_blur
                                  }
                                } else if (searchList.profile_photo === 3) {
                                  profilePhoto = searchList.photo2
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo2_blur
                                  }
                                } else if (searchList.profile_photo === 4) {
                                  profilePhoto = searchList.photo3
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo3_blur
                                  }
                                } else if (searchList.profile_photo === 5) {
                                  profilePhoto = searchList.photo4
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo4_blur
                                  }
                                } else {
                                  profilePhoto = searchList.photo
                                  if (blurPhoto === 1) {
                                    profilePhoto = searchList.photo_blur
                                  }
                                }


                                return (

                                  <div className="col-12 py-2 ">
                                    <div className='yourmatch'>
                                      <div className="row">
                                        <div className="col-4 col-lg-3">
                                          <Link to="#" onClick={(e) => showPopUpButton(e, `/profile-details/${searchList._id}`)}>
                                            <img
                                              src={profilePhoto ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}` : searchList.gender === 'Male' ? 'assets/img/no-image-male.jpg' : 'assets/img/no-image-female.jpg'}
                                              alt="" width={87} />
                                          </Link>
                                        </div>
                                        <div className="col-8 col-lg-6 match-pr-1 p-0">
                                          <h4><Link to="#" onClick={(e) => showPopUpButton(e, `/profile-details/${searchList._id}`)} style={{ color: '#BE3272' }}>
                                            {checkNameShowHide(searchList?.profileSettings?.name_show, planDetailUser) ? searchList?.name : nameMask(searchList?.name)}{" "}
                                          </Link></h4>
                                          <p> {searchList?.dob ? `${ageCalculate(searchList.dob)} yrs,` : ""} {searchList?.height ? `${decimalToFeetInchesWithoutWord(searchList.height)},` : ""} {searchList.religion?.name ? `${searchList.religion?.name},` : ''} {[searchList?.loc_city?.name].filter(Boolean).join("")}</p>
                                          <p>{searchList?.occupation?.name}</p>
                                        </div>
                                        <div className="col-12 col-lg-3">
                                          {



                                            searchList?.interest_sent ? (
                                              <>

                                                <Link to="#" className='dash-interst-btn' style={{ cursor: 'default' }}>
                                                  <img className="img-checker" src="assets/img/icons/check-alt_svgrepo.com-match.png"
                                                    alt="" />
                                                  <span>
                                                    Interest Sent
                                                  </span>
                                                </Link>
                                              </>

                                            )
                                              :
                                              (
                                                <>

                                                  <Link to="#" className='dash-interst-btn' onClick={() => sendInterest(searchList._id, index, 2)}>
                                                    <img className="img-checker" src="assets/img/icons/check-alt_svgrepo.com-match.png"
                                                      alt="" />
                                                    <span>
                                                      Express Interest
                                                    </span>
                                                  </Link>
                                                </>
                                              )

                                          }


                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                )
                              })}



                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-2 col-lg-2">

                  <RightSideChatList matchList={matchList} userBride={userBride} userGrooms={userGrooms} planDetailUser={planDetailUser} formData={formData} />

                </div>
              </div>
            </div>
          </div>
        </section>
      </>



      <FooterPage />

      {/* progress pop start */}
      <div
        className="modal fade success-alert pinkalert"
        id="reg-prog-pop"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content position-relative">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "absolute", right: 15, top: 15 }}
              />
              <div className="intrestsent">
                <h5 className="mt-3">Registration Progress</h5>

                <div className="order-tracker">

                  {/* Aadhaar */}
                  <div className={`step ${verification.aadhaar ? "completed" : ""}`}>
                    <span className="dot">{verification.aadhaar ? "✓" : ""}</span>
                    <span className="label">
                      <div>
                        Aadhaar Verified
                        <br />
                        <em>{verification.aadhaar ? "Completed" : "Pending"}</em>
                      </div>
                      <div className="circle-wrap">
                        <div className="circle">
                          <span>{verifiedStatus}%</span>
                        </div>
                      </div>
                    </span>
                  </div>

                  <div className="line" />

                  {/* Police */}
                  <div className={`step ${verification.police ? "completed" : ""}`}>
                    <span className="dot">{verification.police ? "✓" : ""}</span>
                    <span className="label">
                      <div>
                        Police Verified
                        <br />
                        <em>{verification.police ? "Completed" : ""}</em>
                      </div>
                      <span>{policeVerified}%</span>
                    </span>
                  </div>

                  <div className="line" />

                  {/* Education */}
                  <div className={`step ${verification.education ? "completed" : ""}`}>
                    <span className="dot">{verification.education ? "✓" : ""}</span>
                    <span className="label">
                      <div>
                      Education Verified
                      <br />
                        <em>{verification.education ? "Completed" : ""}</em>
                      </div>
                       <span>{educationVerified}%</span>
                    </span>
                  </div>

                  <div className="line" />

                  {/* Job */}
                  <div className={`step ${verification.job ? "completed" : ""}`}>
                    <span className="dot">{verification.job ? "✓" : ""}</span>
                    <span className="label">
                      <div>
                           Job & Income Verified
                        <br />
                        <em>{verification.job ? "Completed" : ""}</em>
                      </div>
                      <span>{incomeVerified}%</span>
                    </span>
                  </div>

                  <div className="line" />

                  {/* Caste */}
                  <div className={`step ${verification.caste ? "completed" : ""}`}>
                    <span className="dot">{verification.caste ? "✓" : ""}</span>
                    <span className="label">
                      <div>
                          Caste Verified
                        <br />
                        <em>{verification.caste ? "Completed" : ""}</em>
                      </div>
                      
                      
                       <span>{casteVerified}%</span>
                    </span>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/* progress pop end */}

    </>
  )
}

export default Dashboard
